import React from 'react';
import { motion } from 'framer-motion';
import ShareBlogButton from '../../../components/ShareBlogButton/ShareBlogButton';
import './converters-app-project.css';
import convertersAppImage from '../../../assets/images/Converters App Image.png';

const ConvertersAppProject = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Converters <span>App Project</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
         Published On: 10th December 2024<br />
     🕒 Last Updated On: 10th December 2024
      </motion.p>

      <div className="project-content">
        <motion.section 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img 
            src={convertersAppImage} 
            alt="Preview of the Converters App project interface" 
            className="project-image" 
          />
          <h2 className="project-subtitle">Converter Tools</h2>
          <span className="project-category">Tools</span>
          <p className="project-author">Author: Praveen Kumar B</p>
          <p className="project-author">🕒3 Mins Read</p>
          <div className="blog-action-buttons">
            <a href="https://convertersapponline.netlify.app/" className="visit-project-button" target="_blank" rel="noopener noreferrer">→ Visit the Project</a>
            <ShareBlogButton
              blog={{
                id: "converters-app-project",
                title: "Converter Tools",
                path: "/blogs/blogdetail/converters-app-project",
                category: "Tools"
              }}
            />
          </div>
        </motion.section>

        <motion.section 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Overview 🌟</h3>
          <p className="overview-description">
            The Converter Tools app delivers a suite of reliable, fast, and user-friendly conversion utilities—ideal for day-to-day personal and professional use.
          </p>

          <h3 className="section-title">📌 Available Converters</h3>
          <ul className="feature-list">
            <li>
              <strong>💱 Currency Converter:</strong><br />
              Real-time multi-currency exchange rates.
            </li>
            <li>
              <strong>📉 EMI Calculator:</strong><br />
              Calculates EMI, total interest, and payment in INR & USD.
            </li>
            <li>
              <strong>🧾 Monthly Expense Calculator:</strong><br />
              Track income, expenses, summaries, and remaining balance in INR & USD.
            </li>
            <li>
              <strong>⚡ Electricity Bill Calculator:</strong><br />
              Usage-based billing with per-appliance breakdown.
            </li>
            <li>
              <strong>🎚️ Pressure Converter:</strong><br />
              Supports Pascal, Bar, PSI for mechanical uses.
            </li>
            <li>
              <strong>🏎️ Speed Converter:</strong><br />
              kph, mph, m/s, and Mach speed—great for vehicles and aviation.
            </li>
            <li>
              <strong>🌡️ Temperature Converter:</strong><br />
              Celsius, Fahrenheit, Kelvin, and scientific units.
            </li>
            <li>
              <strong>📏 Unit Converter:</strong><br />
              Converts length, area, weight using metric and imperial systems.
            </li>
            <li>
              <strong>📦 Volume Converter:</strong><br />
              Precise volume conversions for cooking, engineering, and science.
            </li>
            <li>
              <strong>💡 Light Converter <em>(Coming Soon)</em>:</strong><br />
              Lumens, lux, candela, foot-candles for lighting and photography.
            </li>
          </ul>

          <h3 className="section-title">📣 More Converters Coming Soon...</h3>
          <p>Stay tuned for more features and tools to simplify your daily conversions. 🚀</p>
        </motion.section>
      </div>
    </motion.div>
  );
};

export default ConvertersAppProject;
